module.exports = __webpack_public_path__ + "static/img/12.ea98f08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/12.jpg
// module id = FLt0
// module chunks = 16